// // import styles from "../HotelGrid/HotelGrid.module.css";
// import HotelCard from "../HotelGrid/HotelCard";

// export default function FeaturedHotelGrid({ hotels }) {
//   if (!hotels || hotels.length === 0) {
//     return null;
//   }

//   return (
//     <section className={styles.wrapper}>
//       <div className={styles.grid}>
//         {hotels.map((hotel) => (
//           <HotelCard
//             key={hotel.id}
//             hotel={hotel}
//           />
//         ))}
//       </div>
//     </section>
//   );
// }
import styles from "../HotelGrid/HotelGridview.module.css";
import HotelCard from "../HotelGrid/HotelCard";

export default function FeaturedHotelGrid({ hotels }) {
  if (!hotels || hotels.length === 0) {
    return null;
  }

  return (
    <section className={styles.wrapper}>
      <div className={styles.grid}>
        {hotels.map((hotel) => (
          <HotelCard
            key={hotel.id}
            hotel={hotel}
          />
        ))}
      </div>
    </section>
  );
}